import {computed} from "mobx";
import {BaseHeaderViewModel} from "../../../models/base-header.view-model";
import {EntityViewModel} from "../../../../../infrastructure/models/entity/entity.view-model";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {MegaHeaderModuleConfig} from "../mega-header-module.config";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {PAGES, ROUTE_NAMES} from "../../../../../core/consts";
import {EntityHeaderModuleState} from "../../entity-header/models/entity-header-module.state";
import {WebsiteModuleState} from "../../../models/website-module.state";

export class MegaHeaderModuleState extends EntityHeaderModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, MegaHeaderModuleConfig, WebsiteModuleState];

  constructor(
    navigationManager: NavigationManager,
    appStore: AppStore,
    logger: LoggerUtils,
    datetimeUtils: DatetimeUtils,
    device: DeviceViewModel,
    termsUtils: TermsUtils,
    config: MegaHeaderModuleConfig,
    websiteModuleState: WebsiteModuleState
  ) {
    super(navigationManager, appStore, logger, datetimeUtils, device, termsUtils, config);

    this.websiteModuleState = websiteModuleState;
  }

  @computed get headerModel(): BaseHeaderViewModel {
    let header = this.entityHeaderModel;

    return header;
  }

  @computed get selectedEntity(): EntityViewModel {
    return this.headerModel?.entityVM;
  }

  @computed get isVisible() {
    const desktopRoute: Array<String> = [ROUTE_NAMES.competitionScores, ROUTE_NAMES.competitorScores, ROUTE_NAMES.game];
    const mobileRoute: Array<String> = [ROUTE_NAMES.competitionScores, ROUTE_NAMES.competitorScores];
    const validRoutes: Array<String> = this.device.isSmallView ? mobileRoute : desktopRoute;

    return validRoutes.includes(this.currentLinkModel?.name);
  }

  @computed get renderStarOnMobile(): Boolean {
    const underGameCenterRoute: Boolean = [ROUTE_NAMES.game].includes(this.currentLinkModel?.name);

    return !underGameCenterRoute;
  }

  @computed get mainTitle(): String {
    const isGameCenter: Boolean = [ROUTE_NAMES.game].includes(this.currentLinkModel?.name);
    const mainTitle: String = isGameCenter ? this.headerModel?.headerLabel : this.websiteModuleState.pageMetadata.entity?.title;

    return mainTitle;
  }

  @computed get isGameRoute(): Boolean {
    const isGameRoute: Boolean = ROUTE_NAMES.game === this.currentLinkModel?.name;

    return isGameRoute;
  }

  @computed get isNewEntitiesPages(): Boolean {
    return this.isCompetitionPage || this.isCompetitorPage || this.isGameCenterPage
  }

  @computed get isGameCenterPage(): Boolean {
    return [ROUTE_NAMES.gameCenterPage, Object.values(PAGES.GAME_CENTER)].flat()?.includes((this.currentLinkModel?.name))
  }

  @computed get isCompetitionPage(): Boolean {
    return [ROUTE_NAMES.competition, Object.values(PAGES.COMPETITION)].flat()?.includes((this.currentLinkModel?.name))
  }

  @computed get isCompetitorPage(): Boolean {
    return [ROUTE_NAMES.competitor, Object.values(PAGES.COMPETITION)].flat()?.includes((this.currentLinkModel?.name))
  }
}
